import { useQuery } from 'react-query';

import { SearchScope } from '@components/pages/SearchPage';
import { ForumPostOptions, ForumPostsResult, getForumPosts } from '@utils/backend-api/forumPosts';
import {
  SubscriberDirectoryParams,
  SubscriberDirectoryResponse,
  getSubscriberDirectory,
} from '@utils/backend-api/subscriber_directory';

export const SCOPE_ARTICLES = 'articles';
export const SCOPE_FORUM = 'forum';
export const SCOPE_DIRECTORY = 'directory';
export const SEARCH_RESULTS_KEY = 'SEARCH_RESULTS_KEY';

const RESULTS_PER_PAGE = 20;
const API_METHODS = {
  [SCOPE_FORUM]: getForumPosts,
  [SCOPE_DIRECTORY]: getSubscriberDirectory,
};

export default function useSearchResults(page: number, query: string, scope: SearchScope) {
  let searchApiParams: ForumPostOptions | SubscriberDirectoryParams;
  if (scope === SCOPE_FORUM) {
    searchApiParams = {
      onSearchPage: true,
      page,
      perPage: RESULTS_PER_PAGE,
      topic: query.toLowerCase(),
    };
  } else if (scope === SCOPE_DIRECTORY) {
    searchApiParams = {
      ai_query: query,
    };
  }
  const { data, isLoading } = useQuery<ForumPostsResult | SubscriberDirectoryResponse>(
    [SEARCH_RESULTS_KEY, scope, searchApiParams],
    () => {
      const apiMethod = API_METHODS[scope];
      if (apiMethod) return apiMethod(searchApiParams);
    },
    { keepPreviousData: true }
  );

  return { data, isLoading };
}
